import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const DeveloperIcon = ({ className, onClick }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" fill="none" viewBox="0 0 18 19" className={className} onClick={onClick}>
      <path
        fill="#fff" d="M14 8.046v-8H4v4H0v14h8v-4h2v4h8v-10h-4zm-10 8H2v-2h2v2zm0-4H2v-2h2v2zm0-4H2v-2h2v2zm4 4H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6v-2h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2v-2h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
      ></path>
    </svg>
  );
};

export default DeveloperIcon;
